import { M8DebitDTO } from 'services/production/types';
import { normalizeM8UserProfile } from 'services/production/utils/normalizeM8UserProfile';
import { Bill } from 'types/state';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const normalizeM8DebitDTO = (m8DebitDTO: M8DebitDTO) => ({
  toBill(): Bill {
    return {
      id: m8DebitDTO.id,
      paid: m8DebitDTO.payed,
      amount: m8DebitDTO.amount,
      amountEUR: m8DebitDTO.eurAmountInit,
      amountRUB: m8DebitDTO.rubAmountInit,
      issuedAt: m8DebitDTO.createdOn,
      clientId: m8DebitDTO.user.id,
      userProfile: normalizeM8UserProfile(m8DebitDTO.user).toUserProfileInfo(),
      bankAccount:
        m8DebitDTO.user.unp !== null
          ? {
              id: `${createUniqueRuntimeNumber()}`,
              name: '',
              unp: m8DebitDTO.user.unp,
            }
          : null,
    };
  },
});
